import Immutable from 'immutable';
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  data: Immutable.List(),
  isFetching: false,
};

export default function alerts(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ALERTS_REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
        data: Immutable.List(),
      });
    case ActionTypes.ALERTS_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: Immutable.List(action.data),
      });

    /**
     * Updates an alert in the set based on id.
     * NOTE: If an alert with the same ID is NOT found,
     * it will be appended to the end of the state.data
     * list.
     */
    case ActionTypes.ALERTS_UPDATE_ALERT:
      return Object.assign({}, state, {
        data: state.data.set(
          state.data.findIndex(a => a.id === action.data.id),
          Immutable.fromJS(action.data),
        ),
        isFetching: false,
      });
    case ActionTypes.ALERTS_REMOVE_ALERT:
      return Object.assign({}, state, {
        data: state.data.filter(a => a.id !== action.data.id),
        isFetching: false,
      });
    default:
      return state;
  }
}
